/**
 * Отклик на переход по ссылке.
 *
 * Нажатие кнопки показывает себя масштабом, но держится оно только
 * пока нажата мышь: на быстром клике человек не успевает увидеть
 * ничего, а страница собирается на сервере секунду (замер 22.10 —
 * «Питание» в среднем 1,3 с на деве). Получалось, что на самое
 * заметное действие — переход — интерфейс отвечал молча.
 *
 * Поэтому: нажатая ссылка остаётся нажатой до смены страницы,
 * и сверху появляется полоса загрузки. Оба отклика местные,
 * сети не ждут, то есть видны в первом кадре.
 */
const PROGRESS_CLASS = 'nav-progress';

export function initNavFeedback() {
    let bar = null;

    // Кто выключил движение в системе, видит полосу целиком и сразу:
    // двухступенчатый рост читался как «появляется частями»
    // (QA 23.10). Движения нет — есть факт «идёт загрузка».
    const still = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function start() {
        if (bar) return;
        bar = document.createElement('div');
        bar.className = PROGRESS_CLASS;
        document.body.appendChild(bar);
        if (still) {
            bar.style.width = '100%';
            return;
        }
        // Ширина растёт в два приёма: сразу до трети — чтобы отклик
        // был виден немедленно, — дальше медленно до девяноста.
        // Сотни не достигаем никогда: полосу убирает сама смена
        // страницы, и доводить её нечестно.
        requestAnimationFrame(() => {
            bar.style.width = '35%';
            setTimeout(() => { if (bar) bar.style.width = '90%'; }, 400);
        });
    }

    function stop() {
        if (!bar) return;
        bar.remove();
        bar = null;
        document.querySelectorAll('.is-navigating').forEach((el) => {
            el.classList.remove('is-navigating');
        });
    }

    document.addEventListener('click', (event) => {
        const link = event.target.closest && event.target.closest('a[href]');
        if (!link) return;
        // Чужие ссылки, новые вкладки, якоря и скачивания нас
        // не касаются: страница остаётся на месте.
        if (link.target && link.target !== '_self') return;
        if (link.hasAttribute('download')) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (event.defaultPrevented) return;
        const href = link.getAttribute('href') || '';
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
        if (link.origin && link.origin !== window.location.origin) return;

        link.classList.add('is-navigating');
        start();
    });

    // Возврат «назад» из кэша браузера показывает прежнюю страницу —
    // вместе с полосой и нажатой ссылкой, если их не снять.
    window.addEventListener('pageshow', stop);
    window.addEventListener('pagehide', stop);
}
